import { Component, OnInit } from '@angular/core';
import {RawNewInfoInterface} from '../raw-new-Info.interface';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
    selector: 'dmp-dyn-raw-new-dialog',
    templateUrl: './dyn-raw-new-dialog.component.html',
    styleUrls: ['./dyn-raw-new-dialog.component.scss'],
    standalone: false
})
export class DynRawNewDialogComponent implements OnInit {
    public configCmp: RawNewInfoInterface;
    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

    ngOnInit(): void {
        this.configCmp = this.config.data;
    }

    onSave($event: boolean) {
        this.ref.close($event);
        this.configCmp.refreshData();
    }

    /** Annulation : on ferme sans rafraîchir, rien n'a été créé. */
    onCancel() {
        this.ref.close();
    }
}
